import React, { useEffect } from 'react';

function Terms() {
      useEffect(() => document.getElementById("start").scrollIntoView({ behavior: "smooth", block: "center" }));

      return (
            <div className="page">
                  <h1 id="start">Terms and Conditions</h1>
                  <p>Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the
            http://Parcelstoday.com website (the "Service") operated by Parcels Today ("us", "we", or "our").</p>
                  <p>We only ask for personal information when we truly need it to provide a service to you. We collect it by fair
            and lawful means, with your knowledge and consent.</p>
                  <p>Your continued use of our website will be regarded as acceptance of our practices around privacy and
                      personal information. If you have any questions about how we handle user data and personal information, feel
            free to contact us.</p>
                  <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms.
            These Terms apply to all visitors, users and others who access or use the Service.</p>
                  <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the
            terms, then you may not access the Service. </p>
                  <p>Our website may link to external sites that are not operated by us. Please be aware that we have no
                      control over the content and practices of these sites, and cannot accept responsibility or liability for
            their respective privacy policies.</p>
                  <p>You are free to refuse our request for your personal information, with the understanding that we may
            be unable to provide you with some of your desired services.</p>

                  <h3>Service</h3>
                  <p>The service is a free to use platform which enables users to plan transportation/logistics that help them find riders
                       close to them to deliver their parcels/goods. It must be emphasized that Parcels Today merely provides the necessary
                       logistics for the procurement of transportation approximate to your location and has no business or interest thereafter
              in the dealings between the rider and the user</p>

                  <h3>Termination</h3>
                  <p>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including
             without limitation if you breach the Terms.</p>
                  <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without
             limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>

                  <h3>Governing Law</h3>
                  <p>These Terms shall be governed and construed in accordance with the laws of Ghana, without regard to its conflict of law provisions.</p>
                  <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these
                       Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute
              the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.</p>

                  <h3>Limitation of Liability</h3>
                  <p>Parcels Today helps in the facilitation of transportation and SHALL NOT BE LIABLE OR RESPONSIBLE FOR THEFT, PROPERTY DAMAGE, HIGH CHARGES OR ANY FORM OF DISCOMFORT THAT MAY ARISE BETWEEN RIDER/AGENT AND CLIENT/USER.
                PARCELS TODAY SHALL NOT BE LIABLE FOR ANY DELAY IN PERFORMANCE.</p>

                  <h3>Changes</h3>
                  <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect.
        This notice may come as a notice on the webpage or via mail. What constitutes a material change will be determined at our sole discretion.</p>
                  <p>By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.</p>

                  <h3>Contact Us</h3>
                  <p>If you have any questions about these Terms and Conditons, please contact us at</p>
                  <a href="mailto:team@parcelstoday.com" target="_blank">team@parcelstoday.com</a>

                  <p>This policy is effective as of 1st May 2018.</p>
            </div>
      )
}

export default Terms;